import styled from 'styled-components'

export const Button = styled.button`
  margin: 1rem 1rem 5rem 1rem;
  padding: 1rem;
  border-radius: 5px;
  font-weight: bold;
  background: #2d60ff;
  color: white;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
  border: none;

`
